// One-time tokens and codes that must not reach Sentry: a password reset token
// in the URL is enough to set a customer's password.
const TOKEN_PATHS = /(\/(?:auth\/reset|accept|verify-email)\/)[^/?#]+/g
const TOKEN_PARAMS = /([?&](?:code|oobCode|token|apiKey)=)[^&#]*/g

export const scrubUrl = url =>
  typeof url === 'string' ? url.replace(TOKEN_PATHS, '$1[redacted]').replace(TOKEN_PARAMS, '$1[redacted]') : url
